import { Box, Button, Flex, Grid, Icon, Text } from '@chakra-ui/react';
import Info from '@ui/components/Info';
import {
  ModalOrDrawerBodyWithMask,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { useStakedNfts } from '@ui/hooks/useCruisers';
import { useTranslations } from '@ui/i18n';
import { ArrowForward } from '@veno-app/icons';
import React from 'react';

import StakeCruiserCard from '../GardenNftDrawersShared/StakeCruiserCard';
import {
  STEP,
  useGardenNftDrawerStore,
} from '../GardenNftDrawersShared/useGardenNftDrawer';
import { useGrowHelpers } from '../GrowHelpersProvider';
import useDoUnstakeNfts from './useDoUnstakeNfts';

function ConfirmContent() {
  const t = useTranslations();
  const setStep = useGardenNftDrawerStore((s) => s.setStep);
  const selectedTokens = useGardenNftDrawerStore((s) => s.selectedTokens);
  const { mutate: doUnstake } = useDoUnstakeNfts();
  const { gardenType } = useGrowHelpers();
  const { data: stakedNfts } = useStakedNfts(gardenType);
  const selectedNfts = stakedNfts?.filter(
    (c) =>
      selectedTokens.find(
        (token) => token.id === c.tokenId && token.collection === c.collection,
      ) !== undefined,
  );
  const notSelectedNfts = stakedNfts?.filter(
    (c) =>
      !selectedTokens.find(
        (token) => token.id === c.tokenId && token.collection === c.collection,
      ),
  );
  const currentNftBoost = stakedNfts
    ? stakedNfts.reduce((prev, c) => c.multiplier + prev, 0)
    : undefined;
  const reducedNftBoost =
    typeof currentNftBoost !== 'undefined' && selectedNfts
      ? currentNftBoost -
        selectedNfts.reduce((prev, c) => c.multiplier + prev, 0)
      : undefined;

  return (
    <>
      <ModalOrDrawerBodyWithMask>
        <Text mx="auto" maxW="300px" textStyle="h3" textAlign="center">
          {t('Helpers to fire')}
        </Text>
        <Grid
          mx="auto"
          mt={4}
          mb={2}
          maxW="min-content"
          rowGap={4}
          templateColumns="repeat(3, 1fr)"
        >
          {selectedNfts?.map((c) => (
            <StakeCruiserCard
              mx={2.5}
              key={c.tokenId}
              checkable={false}
              active={true}
              p="8px 8px 16px"
              {...c}
            >
              <Flex h="full" justify="center" align="center">
                <Box
                  borderWidth="4px"
                  borderColor="red.500"
                  color="red.500"
                  textTransform="uppercase"
                  textStyle="textLink"
                  p="2px 6px 3px"
                  rounded="2px"
                  border=""
                  bg="white"
                  transform="rotate(-15deg)"
                >
                  {t('Fired')}
                </Box>
              </Flex>
            </StakeCruiserCard>
          ))}
        </Grid>
        {!!notSelectedNfts?.length && (
          <Text mt={8} mx="auto" maxW="300px" textStyle="h3" textAlign="center">
            {t('Keep employed')}
          </Text>
        )}
        <Grid
          mx="auto"
          mt={4}
          mb={2}
          maxW="min-content"
          rowGap={4}
          templateColumns="repeat(3, 1fr)"
        >
          {notSelectedNfts?.map((c) => (
            <StakeCruiserCard
              mx={2.5}
              key={c.tokenId}
              checkable={false}
              active={false}
              shadow={undefined}
              {...c}
            />
          ))}
        </Grid>
        <Flex mt={7} flexDir="column" gap={4}>
          <Info
            title={t('No of NFTs staked')}
            value={
              stakedNfts ? (
                <Flex align="center">
                  {stakedNfts.length}{' '}
                  <Icon as={ArrowForward} mx={1} w="15px" h="15px" />
                  {stakedNfts.length - selectedTokens.length ?? 0} / 5
                </Flex>
              ) : undefined
            }
          />
          <Info
            title={t('Total boost')}
            value={
              currentNftBoost !== undefined && reducedNftBoost !== undefined ? (
                <Flex align="center">
                  <Text as="span" color="garden.highlight">
                    +{currentNftBoost.toFixed(3)}x
                  </Text>
                  <Icon as={ArrowForward} mx={1} w="15px" h="15px" />
                  <Text as="span" color="garden.highlight">
                    +{reducedNftBoost.toFixed(3)}x
                  </Text>
                </Flex>
              ) : undefined
            }
          />
        </Flex>
      </ModalOrDrawerBodyWithMask>
      <ModalOrDrawerFooter>
        <Button
          onClick={() => {
            setStep(STEP.pending);
            doUnstake();
          }}
          disabled={!selectedTokens.length}
        >
          {t('Fire helpers')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
}

export default ConfirmContent;
